import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatTableDataSource } from '@angular/material';
import { AuthNoticeService } from '../../../core/auth';
import { ProductsService } from '../../../core/e-commerce';
import { LayoutUtilsService, MessageType } from '../../../core/_base/crud';
import { ReplacementDTO } from '../../../core/models/stock-material-dto.model';

@Component({
    selector: 'kt-dialog-product',
    templateUrl: './dialog-stock.component.html',
    styleUrls: ['./dialog-stock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogStockComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;
    dataSource: MatTableDataSource<ReplacementDTO>;
    displayedColumns: string[] = [
        'code',
        'name',
        'actions',
    ];

    constructor(
        private layoutUtilsService: LayoutUtilsService,
        private productsService: ProductsService,
        private _snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<DialogStockComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: ReplacementDTO[],
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
    ) {
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource(this.data);
        this.authNoticeService.setNotice(null);
        this.initForms();
    }

    initForms() {
        let model;
        if (this.data) {
            model = this.data;
        } else {
            model = {};
        }

        this.detailForm = this.fb.group({
            // id: [model.id, Validators.required],
            effectiveDate: [model.effectiveDate, Validators.required],
            orderDueDays: [model.orderDueDays, Validators.required],
            firstDebtDays: [model.firstDebtDays, Validators.required],
            secondDebtDays: [model.secondDebtDays, Validators.required],
            firstDebtInterest: [model.firstDebtInterest, Validators.required],
            secondDebtInterest: [model.secondDebtInterest, Validators.required],
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }

    delete(element: ReplacementDTO) {
        const _title: string = 'Eliminar material de reemplazo';
        const _description: string = '¿Está seguro que desea eliminar este material de reemplazo?';
        const _waitDesciption: string = 'Eliminando...';
        const _deleteMessage = `El material de reemplazo ha sido eliminado`;

        const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
        dialogRef.afterClosed().subscribe(res => {
            if (!res) {
                return;
            } else {
                this.productsService.deleteMaterial(element.replacementId).subscribe(resp => {
                    this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete, 5000, true, false);
                    this.dialogRef.close(true);
                },
                    error => {
                        this.openSnackBar('Error al intentar eliminar', 'OK');
                    });
            }
        });
    }

    private openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }
}
